
import styled from 'styled-components';
import AnchorLink from 'react-anchor-link-smooth-scroll';

export const AnchorLinkWrapper = styled(AnchorLink)`
font-weight: bold !important;
`